export default class CmsAnimation {
    static init(): void {
        const cmsSection = document.querySelector<HTMLElement>('.cms-desktop-section');
        if (!cmsSection) return;
        const bgCircle = document.querySelector<HTMLElement>('.cms-circle-bg');
        const texts = Array.from(document.querySelectorAll<HTMLElement>('.react-desktop-item__text'));
        const textDeco = document.querySelectorAll<HTMLElement>('.cms-decoration-item');
        const textIcons = document.querySelectorAll<HTMLElement>('.cms-decoration-icon');

        if (!bgCircle || !textDeco || !textIcons || texts.length === 0) {
            return;
        }

        let animationStarted = false;

        const initStyles = () => {
            bgCircle.style.opacity = '0';
            textDeco.forEach((deco) => {
                deco.style.opacity = '0';
            });
            textIcons.forEach((icon) => {
                icon.style.opacity = '0';
            });
            texts.forEach((text) => {
                text.style.opacity = '0';
            });
        };

        initStyles();

        const animateCircle = () => {
            bgCircle.style.transition = 'opacity 0.25s ease';
            bgCircle.style.opacity = '1';
        };

        const animateDeco = () => {
            textDeco.forEach((deco) => {
                deco.style.transition = 'opacity 0.25s ease';
                deco.style.opacity = '1';
            });
        };

        const animateIcons = () => {
            textIcons.forEach((icon) => {
                icon.style.transition = 'opacity 0.25s ease';
                icon.style.opacity = '1';
            });
        };

        const animateTexts = () => {
            texts.forEach((text) => {
                text.style.transition = 'opacity 0.25s ease';
                text.style.opacity = '1';
            });
        };

        const startAnimation = () => {
            if (animationStarted) return;
            animationStarted = true;

            animateCircle();
            setTimeout(() => {
                animateDeco();
                animateIcons();
                animateTexts();
            }, 500);
        };

        const handleScroll = () => {
            const sectionTop = cmsSection.getBoundingClientRect().top;
            const sectionHeight = cmsSection.offsetHeight;
            const scrollPercentage = ((window.innerHeight - sectionTop) / sectionHeight) * 100;

            if (scrollPercentage >= 50) {
                startAnimation();
                window.removeEventListener('scroll', handleScroll);
            }
        };
        window.addEventListener('scroll', handleScroll);
    }
}
